import { render, staticRenderFns } from "./RewordList.vue?vue&type=template&id=5cfd5256&scoped=true"
import script from "./RewordList.vue?vue&type=script&lang=js"
export * from "./RewordList.vue?vue&type=script&lang=js"
import style0 from "./RewordList.vue?vue&type=style&index=0&id=5cfd5256&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd5256",
  null
  
)

export default component.exports